export default "__VITE_ASSET__CSg3bwmz__"